import { render } from "./bank-tab.vue?vue&type=template&id=09ca595f"
import script from "./bank-tab.vue?vue&type=script&lang=js"
export * from "./bank-tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__